import { Link } from "react-router-dom";
import recentlettericon from "../assets/images/recent_letter-icon.png";
import contactusicon from "../assets/images/contact-us-icon.png";
import joinusicon from "../assets/images/reservation_icon.png";
import followusicon from "../assets/images/fb_icon.png";


export default function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <ul>
          <CustomExternalLink to="/media/pdfs/Conner_Family_Reunion_Letter_2025.pdf" img={recentlettericon} alt="document with clock on it">Celebrate With Us</CustomExternalLink>
          <VerticalBar />
          <CustomLink to="/contactus" img={contactusicon} alt="envelope with letter in it">Contact Us</CustomLink>
          <VerticalBar />
          <CustomLink to="/location" img={joinusicon} alt="calendar with finger pointing to day">Join Us</CustomLink>
          <VerticalBar />
          <CustomLink to="http://www.facebook.com/groups/ConnerReunion" img={followusicon} alt="envelope with letter in it">Follow Us</CustomLink>
        </ul>
      </div>
    </footer>
  );
}

function CustomExternalLink({to, img, alt, children, ...props}) {
  const target = "connertab";
  return (
    <li>
      <a href={to} target={target}>
        <div>{children}</div>
        <div><img src={img} alt={alt} /></div>
      </a>
    </li>
  );
}

function CustomLink({to, img, alt, children, ...props}) {
  const target = (to.startsWith('http')) ? "connertab" : "";
  return (
    <li>
      <Link to={to} target={target} {...props}>
        <div>{children}</div>
        <div><img src={img} alt={alt} /></div>
      </Link>
    </li>
  );
}

function VerticalBar() {
  return (
    <li aria-hidden="true"><div className="vbar"></div></li>
  );
}